module.exports = __webpack_public_path__ + "static/media/star.91bd306a.svg";